// Shared lesson-id helpers. Lesson ids come in two shapes:
//   • pack form   — "pack:<packId>::L<n>"   (BattlePackPicker / teaching levels)
//   • seed form   — "people-L3" / "people_l3" (seeded global lessons)
// These were re-implemented in GameView, RaceResults, and the race worker;
// the client sites now share this module.
import { getTeachingLevel } from "../data/teaching-levels";
import { SEED_LESSONS } from "../data/seed-lessons";

/** Resolve the 1-based teaching level index from a lesson id, or undefined. */
export function levelIndexFromLessonId(id: string | null | undefined): number | undefined {
  if (!id) return undefined;
  const m = /^pack:.+?::L(\d+)$/.exec(id);
  if (m) return Number(m[1]);
  const m2 = /[-_]L(\d+)$/i.exec(id);
  if (m2) return Number(m2[1]);
  const seed = SEED_LESSONS.find((l) => l.id === id);
  return seed?.orderIndex ?? undefined;
}

/** True when the lesson is the final survival (Battle Royale) level. */
export function isFinaleLesson(id: string | null | undefined): boolean {
  const idx = levelIndexFromLessonId(id);
  return idx != null && getTeachingLevel(idx)?.courseMode === "double-spinner";
}
